import {
  CardRenderWithInfiniteScroll,
  CardsRender,
  FullRender,
  FullRenderWithInfiniteScroll
} from '../components';
import { CLASSIC } from '../../../constants';

function getListComponent(isCard, paginationType) {
  const isNotClassic = paginationType !== CLASSIC;
  if (isCard) return isNotClassic ? CardRenderWithInfiniteScroll : CardsRender;
  return isNotClassic ? FullRenderWithInfiniteScroll : FullRender;
}

export default getListComponent;
